/**
 * WCAG contrast helper.
 *
 * For a data-driven background color (label/tag chips), pick the foreground
 * (near-black or white) with the higher contrast ratio so small text on
 * arbitrary brand colors still meets WCAG AA (4.5:1) where possible.
 */

const DARK = '#0f172a';
const LIGHT = '#ffffff';

function channelLuminance(c) {
  const s = c / 255;
  return s <= 0.04045 ? s / 12.92 : Math.pow((s + 0.055) / 1.055, 2.4);
}

function relativeLuminance(r, g, b) {
  return 0.2126 * channelLuminance(r) + 0.7152 * channelLuminance(g) + 0.0722 * channelLuminance(b);
}

/**
 * Returns DARK or LIGHT (whichever contrasts better) for the given hex bg.
 * Falls back to white for unparseable input.
 */
export function contrastText(hex, dark = DARK, light = LIGHT) {
  if (!hex || typeof hex !== 'string') return light;
  let h = hex.trim().replace(/^#/, '');
  if (h.length === 3) h = h.split('').map((c) => c + c).join('');
  if (!/^[0-9a-fA-F]{6}$/.test(h)) return light;
  const r = parseInt(h.slice(0, 2), 16);
  const g = parseInt(h.slice(2, 4), 16);
  const b = parseInt(h.slice(4, 6), 16);
  const L = relativeLuminance(r, g, b);
  const contrastWhite = 1.05 / (L + 0.05);
  const contrastBlack = (L + 0.05) / 0.05;
  return contrastBlack >= contrastWhite ? dark : light;
}

export default contrastText;
